<template>
  <div
    class="product-card-container"
    :class="{ active: activeCard }"
    @click="activeCard = !activeCard"
  >
    <div class="product-card">
      <div class="product-card__image">
        <img :src="require('../../public/image/product/' + carddata.img)" />
      </div>
      <div class="product-card__name">{{ carddata.name }}</div>
      <div class="product-card__price">
        {{ carddata.price }}<span>تومان</span>
      </div>
      <div class="product-card__buy"><span>سفارش</span></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["carddata"],
  data() {
    return {
      activeCard: false,
    };
  },
};
</script>

<style></style>
